import _ from 'lodash';
import fetcher from '../API';

export const PAGE_SIZE = 15;

export const SEARCH_PRODUCTS = "SEARCH_PRODUCTS";
export const SEARCH_PRODUCTS_PENDING = "SEARCH_PRODUCTS_PENDING"
export const SEARCH_PRODUCTS_FULFILLED = "SEARCH_PRODUCTS_FULFILLED";
export const SEARCH_PRODUCTS_REJECTED = "SEARCH_PRODUCTS_REJECTED";

export const FETCH_PRODUCT_DETAIL = 'FETCH_PRODUCT_DETAIL';
export const FETCH_PRODUCT_DETAIL_FULFILLED = 'FETCH_PRODUCT_DETAIL_FULFILLED';

export const TAGGING_PRODUCTS = 'TAGGING_PRODUCTS';
export const TAGGING_PRODUCTS_FULFILLED = 'TAGGING_PRODUCTS_FULFILLED';
export const TAGGING_PRODUCTS_REJECTED = 'TAGGING_PRODUCTS_REJECTED';

export const addTagsToSkus = (skuIds, tags, callBack) => {
    return dispatch => {
        const request = fetcher.patch(`api/v1/products/_batch/skus/tags`, { proSkuIds: skuIds, replace: tags })
            .then((response) => {
                callBack(true, null);
            })
            .catch((error) => {
                callBack(false, error);
            });
    }
}

export const removeTagsToSkus = (skuIds, tags, callBack) => {
    return dispatch => {
        const request = fetcher.patch(`api/v1/products/_batch/skus/tags`, { proSkuIds: skuIds, remove: tags })
            .then((response) => {
                callBack(true);
            })
            .catch((error) => {
                callBack(false, error);
            });
    }
}

export const addingTags = (productIds, tags, callBack) => {
    return dispatch => {
        const ids = Array.from(new Set(productIds.filter(item => item)));
        let failedIds = [...ids]; // 用于记录add tag失败的id
        let count = 0; // 用于记录tag的id数，当count === productIds时，代表所有商品都尝试tag过了。
        for (const productId of ids) {
            fetcher.patch(`api/v1/products/${productId.trim()}/tags`, { add: tags })
                .then((response) => {
                    dispatch({
                        type: TAGGING_PRODUCTS_FULFILLED,
                        payload: response.data
                    });
                    count += 1;
                    _.remove(failedIds, (failedId) => {
                        return failedId === response.data.id;
                    });

                    if (count === ids.length) {
                        callBack(failedIds);
                    }
                })
                .catch((error) => {
                    count += 1;
                    alert(`${error} \n\n failed id: ${productId}`);
                    if (count === ids.length) {
                        callBack(failedIds);
                    }
                });
        }
    }
}

export const removingTags = (productIds, tags, callBack) => {
    return dispatch => {
        let failedIds = [...productIds];// 用于记录remove tag失败的id
        let count = 0;

        for (const productId of productIds) {
            const request = fetcher.patch(`api/v1/products/${productId}/tags`, { remove: tags })
                .then((response) => {
                    dispatch({
                        type: TAGGING_PRODUCTS_FULFILLED,
                        payload: response.data
                    });
                    count += 1;
                    _.remove(failedIds, (failedId) => {
                        return failedId === response.data.id;
                    });
                    if (count == productIds.length) {
                        callBack(failedIds);
                    }
                })
                .catch((error) => {
                    count += 1;
                    alert(`${error} \n\n failed id: ${productId}`);
                    if (count === productIds.length) {
                        callBack(failedIds);
                    }
                });
        }
    }
}

export const fetchProduct = (productId, callback) => {
    return dispatch => {
        fetcher.get(`api/v1/products/${productId}?promo=true&pinInfo=true`)
            .then(response => {
                dispatch({
                    type: FETCH_PRODUCT_DETAIL_FULFILLED,
                    payload: response.data
                });
                if (callback) {
                    callback();
                }
            })
    }
}
